import {
  AvatarFallback,
  AvatarImage,
  Avatar as ShadcnAvatar,
} from "@/components/ui/avatar";
import { useRecordContext } from "ra-core";

import type { Contact } from "../types";
import { getContactDetail, getContactDisplayName } from "./contact-details";

export const Avatar = (props: {
  record?: Contact;
  width?: 20 | 25 | 40;
  height?: 20 | 25 | 40;
  title?: string;
}) => {
  const record = useRecordContext<Contact>(props);
  // Sem record não há o que desenhar. A condição composta abaixo já cobria esse
  // caso por acidente (getContactDisplayName(undefined) === ""), mas depender
  // disso é frágil — e o TS não conseguia estreitar `record` depois dela.
  if (!record) return null;
  // If we come from company page, the record is defined (to pass the company as a prop),
  // but neither of those fields are and this lead to an error when creating contact.
  if (!record.avatar && !getContactDisplayName(record)) {
    return null;
  }

  const size = props.width || props.height;
  const sizeClass =
    props.width === 20
      ? `w-[20px] h-[20px]`
      : props.width === 25
        ? "w-[25px] h-[25px]"
        : "w-10 h-10";

  return (
    <ShadcnAvatar className={sizeClass} title={props.title}>
      <AvatarImage src={record.avatar?.src ?? undefined} />
      <AvatarFallback className={size && size < 40 ? "text-[10px]" : "text-sm"}>
        {(getContactDetail(record, "name", "") ?? "").charAt(0).toUpperCase()}
      </AvatarFallback>
    </ShadcnAvatar>
  );
};
